const requiredText = "Required";

const validateRequired = value => !value && requiredText;

const yesValue = "Yes";
const prefixArray = ["Employee", "Spouse", "FirstChild", "SecondChild", "ThirdChild"];

const validateRHIHD201907 = (values, errors) => {
  const requiredMapping = {
    Smoke: ["SmokeQuantity", "SmokeNoOfYears"],
    ConsumeAlcohol: ["AlcoholType", "AlcoholQuantity"],
    Adventure: ["AdventureInfo", "AdventureInfoDetails"],
    Pregnant: ["PregnantDurationValue", "PregnantDurationUnit"],
  };
  for (const prefix of prefixArray) {
    // eslint-disable-next-line guard-for-in
    for (const field in requiredMapping) {
      const toCheckFieldArray = requiredMapping[field];
      for (const toCheckField of toCheckFieldArray) {
        if (
          values[`${prefix}${field}`] === yesValue &&
          values[`${prefix}${toCheckField}`].trim() === ""
        ) {
          errors[`${prefix}${toCheckField}`] = requiredText;
        }
      }
    }
  }

  const requiredMappingSpecial = {
    RegularDoc: ["RegularDoctorName", "RegularClinicAddress"],
  };
  for (const prefix of prefixArray) {
    for (const field in requiredMappingSpecial) {
      if (values[`${prefix}${field}`] === yesValue) {
        const toCheckFieldArray = requiredMappingSpecial[field];
        for (const toCheckField of toCheckFieldArray) {
          if (values[toCheckField].trim() === "") {
            errors[toCheckField] = requiredText;
          }
        }
      }
    }
  }
};

const validateForm = (values, { form, data }) => {
  const errors = {};

  Object.values(data).forEach(field => {
    if (field.isRequired && !values[field.fieldName] && !field.isReadOnly) {
      errors[field.fieldName] = requiredText;
    }
  });

  if (form === "RHIHD201907") {
    validateRHIHD201907(values, errors);
  }

  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/validation.js